/* eslint-disable @typescript-eslint/no-explicit-any */
import { eventChannel } from 'redux-saga';
import * as R from 'ramda';

export function createSocketChannel(ws: any): any {
  return eventChannel((emitter) => {
    let messages: any[] = [];
    window.setInterval(() => {
      emitter({ events: [...messages] });
      messages = [];
    }, 4000);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ws.onmessage = (event: any) => {
      messages = R.prepend(JSON.parse(event.data))(messages);
    };
    return () => {
      // do whatever to interrupt the socket communication here
    };
  });
}
